<div class="st-container">
  <st #st [columns]="columns" [responsive]="false" [data]="data"></st>
</div>
